/**
 * Formats a results-panel cell the way the answer's preview table reads: thousands
 * separators, whole numbers for large figures, and a "$" on money columns
 * ("306694306.29" → "$306,694,306"; 8966 → "8,966").
 *
 * Only measures are formatted. A numeric-looking string in any other column (an HS
 * code, an id, a year) is left exactly as it came.
 */

const MONEY_COLUMN = /\(usd\)|\busd\b|\bvalue\b|\bprice\b|\bamount\b|\bcost\b|\$/i;
const MEASURE_COLUMN = /shipment|value|weight|quantity|volume|count|total|amount|price|cost|usd|kg|teu|container|record|unit/i;
const NUMERIC = /^-?\d+(\.\d+)?$/;

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})(?:[T ][\d:.]+Z?)?$/;
const ISO_MONTH = /^(\d{4})-(\d{2})$/;

/** ISO dates read as "Jan 05, 2026" and ISO months as "Jan, 2026"; any other text is returned as is. */
export function formatDate(text: string): string {
  const value = text.trim();
  const day = ISO_DAY.exec(value);
  if (day && Number(day[2]) >= 1 && Number(day[2]) <= 12) return `${MONTHS[Number(day[2]) - 1]} ${day[3]}, ${day[1]}`;
  const month = ISO_MONTH.exec(value);
  if (month && Number(month[2]) >= 1 && Number(month[2]) <= 12) return `${MONTHS[Number(month[2]) - 1]}, ${month[1]}`;
  return text;
}

export function formatCell(column: string, value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") {
    const date = formatDate(value);
    if (date !== value) return date;
  }
  const number = typeof value === "number" ? value : NUMERIC.test(value.trim()) && MEASURE_COLUMN.test(column) ? Number(value) : null;
  if (number === null || !Number.isFinite(number)) return String(value);

  const text = number.toLocaleString("en", { maximumFractionDigits: Math.abs(number) >= 1000 || Number.isInteger(number) ? 0 : 2 });
  if (!MONEY_COLUMN.test(column)) return text;
  return number < 0 ? `-$${text.slice(1)}` : `$${text}`;
}
